export default "__VITE_ASSET__CDsdijEo__"